/**
 * @generated SignedSource<<b7aef15c10fe8e298f27c329914353ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTilesCarousel_user">;
  readonly " $fragmentType": "HpSharedVideoComponentCarousel_user";
};
export type HpSharedVideoComponentCarousel_user$key = {
  readonly " $data"?: HpSharedVideoComponentCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTilesCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e7b8393660c7236a7510229fc536f058";

export default node;
